import React, {type JSX} from 'react';
import {Box} from '@mui/material';
import {HealthConnectLogoIcon} from '../../assets/icons/healthConnectLogoIcon';

function Logo(): JSX.Element {
  return (
    <Box sx={{height: '56px', width: 'auto'}}>
      <HealthConnectLogoIcon sx={{height: '100%', width: 'auto'}} />
    </Box>
  );
}

export default Logo;
